const SERVER_PATH = process.env.REACT_APP_API_URL;
export const API = {
  GET_PROJECT_FILES: ":5000/get_project_files",
  GET_STATUS: ":5000/get_status",
  MODEL_PARAMETERS: ":5504/model_parameters",
  PUBLIC_DOC: ":5000/public_doc",
  CREATE_VECTORSTORE: ":5501/create_vectorstore",
  GET_TABLE: ":5000/get-table",
  DELETE: ":5000/delete",
  EVIDENCE_REPORT: ":5507/evidence_report",
  GET_ANALYSIS: ":5506/analysis",
  GET_CONFIGURATION: ":5503/get_configuration",
  GET_PID: ":5505/pid",
  GET_HISTORY: ":5505/get_history",
  USE_MODEL_GET_HISTORY: ":5502/get_history",
  USE_MODEL_EVIDENCE_REPORT: ":5502/evidence_report",
  USE_MODEL_GET_PID: ":5502/pid",
  USE_MODEL_DELETE_CHAT: ":5502/delete_entry",
  SAVE_PROJECT_ACCESS: ":5000/save_project_access",
  CLUSTER_GENERATE_PRESIGNED_URL: ":5509/generate-presigned-url",
  CLUSTER_PUBLIC_DOC: ":5509/public_doc",
  CLUSTER_DELETE: ":5509/delete",
  CLUSTER_GET_INFO: ":5509/get_info",
  CLUSTER_DOCUMENTS: ":5509/cluster_documents",
////////////////////////////////////////////////////////////////////////////////////////////
  model_parameters: "/model_parameters",
  summarizeDocuments_generate_presigned_url:
    "/summarizeDocuments-generate-presigned-url",
  summarizeDocuments_public_doc: "/summarizeDocuments-public_doc",
  summarizeDocuments_get_table: "/summarizeDocuments-get_table",
  summarizeDocuments_get_project_files: "/summarizeDocuments-get_project_files",
  summarizeDocuments_save_project_access:
    "/summarizeDocuments-save_project_access",
  summarizeDocuments_delete: "/summarizeDocuments-delete",
  summarizeDocuments_get_folder_name: "/summarizeDocuments-get_folder_name",
  summarizeDocuments_summarize_pdfs: "/summarizeDocuments-summarize_pdfs",
  summarizeDocuments_show_history: "/summarizeDocuments-show_history",
  summarizeDocuments_get_configuration: "/summarizeDocuments-get_configuration",
  summarizeDocuments_add_configuration: "/summarizeDocuments-add_configuration",
  similarDocuments_generate_presigned_url:
    "/similarDocuments-generate-presigned-url",
  similarDocuments_public_doc: "/similarDocuments-public_doc",
  similarDocuments_get_table: "/similarDocuments-get_table",
  similarDocuments_get_project_files: "/similarDocuments-get_project_files",
  similarDocuments_save_project_access: "/similarDocuments-save_project_access",
  similarDocuments_delete: "/similarDocuments-delete",
  similarDocuments_get_folder_name: "/similarDocuments-get_folder_name",
  similarDocuments_create_vectorstore: "/similarDocuments-create_vectorstore",
  similarDocuments_generate_presigned_url_upload:
    "/similarDocuments-generate-presigned-url-upload",
  similarDocuments_get_score: "/similarDocuments-get_score",
  HabilisGetAPI_get_history: "/HabilisGetAPI-get_history",
  HabilisGetAPI_pid: "/HabilisGetAPI-pid",
  get_configuration: "/get_configuration",
  features_get_folder_name: "/features-get_folder_name",
  features_generate_presigned_url: "/features-generate-presigned-url",
  features_public_doc: "/features-public_doc",
  features_get_table: "/features-get-table",
  features_save_project_access: "/features-save_project_access",
  features_get_project_files: "/features-get_project_files",
  features_login: "/features-login",
  features_get_status: "/features-get_status",
  features_delete: "/features-delete",
  create_vectorstore: "/create_vectorstore",
  DynamicLLMFromDb_evidence_report: "/DynamicLLMFromDb-evidence_report",
  DynamicLLMFromDb_delete_entry: "/DynamicLLMFromDb-delete_entry",
  DirectLLM_get_history: "/DirectLLM-get_history",
  DirectLLM_pid: "/DirectLLM-pid",
  DirectLLM_delete_entry: "/DirectLLM-delete_entry",
  DirectLLM_evidence_report: "/DirectLLM-evidence_report",
  compareDocuments_get_folder_name: "/compareDocuments-get_folder_name",
  compareDocuments_get_project_files: "/compareDocuments-get_project_files",
  compareDocuments_compare_pdfs: "/compareDocuments-compare_pdfs",
  compareDocuments_show_history: "/compareDocuments-show_history",
  compareDocuments_generate_presigned_url:
    "/compareDocuments-generate-presigned-url",
  compareDocuments_public_doc: "/compareDocuments-public_doc",
  compareDocuments_save_project_access: "/compareDocuments-save_project_access",
  compareDocuments_delete: "/compareDocuments-delete",
  clustering_cluster_documents: "/clustering-cluster_documents",
  clustering_get_table: "/clustering-get_table",
  clustering_save_project_access: "/clustering-save_project_access",
  clustering_get_info: "/clustering-get_info",
  clustering_get_folder_name: "/clustering-get_folder_name",
  clustering_generate_presigned_url: "/clustering-generate-presigned-url",
  clustering_public_doc: "/clustering-public_doc",
  clustering_delete: "/clustering-delete",
  analysisGPT4_analysis: "/analysisGPT4-analysis",
};
export const getURL = (API_KEY) => {
  return SERVER_PATH + API[API_KEY];
};
